export const NICE_CONFIRM_DIALOG_KEY = 'Confirm_Dialog_Who_Remember_Your_Choice';
export const remindTheirChoice = (dialogId: string): boolean | null => {
  const confirmDialogValues = getLocalStorageItem(NICE_CONFIRM_DIALOG_KEY) || {};
  const value = confirmDialogValues[dialogId];
  return value ?? null;
};

export const getLocalStorageItem = <T>(token: string): T => {
  const value = window.localStorage.getItem(token);
  try {
    return JSON.parse(value as string) as T;
  } catch {}
  return value as unknown as T;
};

export interface ConfirmData {
  message?: string;
  confirmText?: string;
  cancelText?: string;
  rememberMyChoiceDialogId?: string;
  doNotRemindMeText?: string;
  showCloseButton?: boolean;
  rememberOnlyIfTrue?: boolean;
  title?: string;
}
